import { render, staticRenderFns } from "./SchemaFieldsetEditor.vue?vue&type=template&id=31723938&"
import script from "./SchemaFieldsetEditor.vue?vue&type=script&lang=js&"
export * from "./SchemaFieldsetEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports